import "core-js/stable";
import "regenerator-runtime/runtime";
import {
	createApp,
	defineAsyncComponent
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'
import qs from 'qs-stringify';

import ElementPlus from 'element-plus'
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/lib/locale/lang/zh-cn'

const app = createApp(App);
app.use(router)
app.use(store)
app.use(ElementPlus, {
	locale
})
app.config.devtools = true

// 全局方法
app.config.globalProperties.$set = (key, val) => {
	if (typeof key == 'string') {
		store.commit('set', {
			[key]: val
		})
	} else {
		store.commit('set', key)
	}
};
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$qs = qs;
app.config.globalProperties.$vue = app;
app.config.globalProperties.$opened = function(that) {
	that.$nextTick(() => {
		document.querySelectorAll('.el-overlay').forEach(e => e.scrollTop = 0)
	})
};

// 全局v-directive方法
app.directive('resize', {
	mounted(el, binding) {
		// el为绑定的元素，binding为绑定给指令的对象
		let width = el.clientWidth,
			height = el.clientHeight;
		function isReize() {
			if (width !== el.clientWidth || height !== el.clientHeight) {
				binding.value({width, height}); // 回调函数
			}
			width = el.clientWidth;
			height = el.clientHeight;
		}
		el.__vueSetInterval__ = setInterval(isReize, 300);
	},
	unmounted(el) {
		clearInterval(el.__vueSetInterval__);
	}
})

// 全局window方法
window.$in = (url) => {
	return defineAsyncComponent(() => import(`/views${'/'+url}`))
};

// 全局组件
app.component('Head', defineAsyncComponent(() => import('@/views/components/Head.vue'))) //头
app.component('Foot', defineAsyncComponent(() => import('@/views/components/Foot.vue'))) //脚



app.mount('#app')
